import React, { useState, useEffect } from 'react';

import {
    Checkbox,
    Fieldset,
    Button
} from 'react95';


import { portfolio } from './techData'

const categories = ['frontend', 'backend', 'software', 'others'];

export const Tech = () => {
  // Będziemy przechowywać w tablicy np [frontenr] albo [frontent, others]
  const [selectedCategories, setSelectedCategories] = useState(["frontend"]);
  console.log(selectedCategories);
  // To jest funkcja ktora zwraca funkcje
  // https://blog.bitsrc.io/understanding-higher-order-functions-in-javascript-75461803bad
  const toggleCategory = categoryName => () => {
    // jezeli ta kategoria jest w tablicy to ja wywalamy
    if (selectedCategories.includes(categoryName)) {
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
      // Zwracamy wszystkoe wybrane kategorie OPRORCZ tej podanej w categoryName
      setSelectedCategories(selectedCategories.filter(name => name !== categoryName));
    } else {
      // w przeciwnym wypadku dodajemy ją
      // To jest jeden z wielu sposobow łączenia tablic
      // https://gist.github.com/yesvods/51af798dd1e7058625f4
      setSelectedCategories([...selectedCategories, categoryName]);
    }
  };

  const toggleAll = () => {
    // jezeli mamy tyle zaznaczonych co liczba kategorii to odznaczamy wszystko
    if (selectedCategories.length === categories.length) {
      setSelectedCategories([]);
    } else {
      // w przeciwmnym wypadku dajemy wszystkie dostepne kategorie
      setSelectedCategories(categories);
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <Fieldset label="Filters">
            <Checkbox
              name="allToppings"
              label="All"
              value="allToppings"
              // To jest true kiedy przynajmniej jedna jest zaznaczona ale nie wszystkie
              indeterminate={
                selectedCategories.length > 0 && selectedCategories.length < categories.length
              }
              // Gdy mamy tyle zaznaczen co kategorii to mamy all
              checked={selectedCategories.length === categories.length}
              onChange={toggleAll}
              style={{ marginRight: '15px' }}
            />
            {categories.map(categoryName => (
              <Checkbox
                checked={selectedCategories.includes(categoryName)}
                // Toggle category to funkcja zwracajaca funkcje
                onChange={toggleCategory(categoryName)}
                value={categoryName}
                label={categoryName}
                name="ingredients"
                style={{ marginRight: '15px' }}
              />
            ))}
          </Fieldset>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Fieldset label="Skills">
            {portfolio.map(item => (
              <Button
                className="m-1"
                style={{
                  float: 'left',
                  display: item.category.some(categoryName =>
                    selectedCategories.includes(categoryName)
                  )
                    ? 'block'
                    : 'none',
                }}
              >
                {item.name}
              </Button>
            ))}
          </Fieldset>
        </div>
      </div>
    </div>
  );
};

